import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;

  .title {
    text-align: center;
    margin-bottom: 16px; 
  }

  .button {
    display: block;
    margin: 0 auto;
  }
`;

export default { Wrapper };
